export default {
    semantic: {
        primary: {
            // 50: '#4372A0',
            // 100: '#4372A0',
            // 200: '#4372A0',
            // 300: '#4372A0',
            // 400: '#4372A0',
            500: '#4372A0',
            // 600: '#4372A0',
            // 700: '#4372A0',
            // 800: '#4372A0',
            // 900: '#4372A0',
            // 950: '#4372A0'
        }
    }
};